import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { queryGetEmailCampaignAudience } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import AudienceDisplay from './AudienceDisplay'

const ListGraphql = compose(
  graphql(queryGetEmailCampaignAudience, {
    name: 'audience',
    fetchPolicy: 'network-only'
  })
)(
  observer(
    class ListView extends Component {
      render() {
        const { audience: { loading, getAudienceList } } = this.props;
        return (
          <React.Fragment>
            {loading && <LoadingPanel />}
            {!loading && getAudienceList && getAudienceList.length && <AudienceDisplay audience={getAudienceList[0]} /> }                
          </React.Fragment>
        );
      }
    }
  )
);

export default observer(
  class List extends Component {
    render() {
      return <ListGraphql />;
    }
  }
);




// WEBPACK FOOTER //
// ./src/module-email-campaign/audience/AudienceListWithQuery.js